import { Flex, Box, Image, Text, Button, Grid } from '@chakra-ui/react';
import { learnMoreInfo } from '../../../common/constants';
import { FaArrowRight } from 'react-icons/fa';

const SixthLayer = () => {
  return (
    <Grid
      minH="90vh"
      pt="90px"
      mb="100px"
      w="100%"
      align="center"
      gap="27px"
      placeItems="center"
      gridTemplateColumns={{ base: '1fr', md: 'repeat(3,1fr)' }}
    >
      {learnMoreInfo?.map((data, i) => {
        return (
          <Box
            borderRadius="25px"
            h="fit-content"
            key={i}
            bg={i === 1 ? '#F3C948' : '#0F172B'}
            color={i === 1 ? '#000' : '#ffff'}
            py={{ base: '24px', md: '2rem' }}
            px="24px"
            textAlign="center"
          >
            <Box>
              <Image mx="auto" w="80x" h="80px" src={data.img} />
            </Box>
            <Text pt="1rem" lineHeight="1.2" fontWeight={700} fontSize="2rem">
              {data.title}
            </Text>

            <Flex
              w="fit-content"
              cursor="pointer"
              mx="auto"
              justifyContent="center"
              alignItems='center'
              gap='5px'
              pt="2rem"
            >
              <Text>Learn More</Text>
              <FaArrowRight />
            </Flex>
          </Box>
        );
      })}
    </Grid>
  );
};
export default SixthLayer;
